module.exports = __webpack_public_path__ + "img/1F1F3-1F1FF.5af44b4f.svg";